import React, { useContext } from 'react'
import CommonBox from '../CommonBox'
import GifImagesSection from '../GifImagesSection'
import LoginContext from '../../context'
import SingleEventSection from '../SingleEventSection'

const SingleEvent = () => {
    const { isAuthenticated } = useContext(LoginContext)
    return (
        <>
            <section className='single-notice'>
                <CommonBox heading="이벤트" englishHeading=" event" isEnglishHeadingOnMobile={true} isAuthenticated={isAuthenticated}>
                    <SingleEventSection />
                </CommonBox>
            </section>
            <section className='gif-section flex lg:hidden items-center justify-center'>
                <GifImagesSection />
            </section>
        </>
    )
}
export default SingleEvent

